function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.92366 34.6626L7.1068 32.8457L20.1041 19.7088L32.1231 27.8145L43.1637 16.2148L45.1204 18.0317L32.4026 31.3084L20.3837 23.0629L8.92366 34.6626Z",
  fill: "#ADB3BA",
  stroke: "#ADB3BA",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08622 38.0162C10.4018 38.0162 12.2789 36.1391 12.2789 33.8235C12.2789 31.508 10.4018 29.6309 8.08622 29.6309C5.77068 29.6309 3.89355 31.508 3.89355 33.8235C3.89355 36.1391 5.77068 38.0162 8.08622 38.0162Z",
  fill: "#E91E63"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.2484 25.5787C22.564 25.5787 24.4411 23.7016 24.4411 21.386C24.4411 19.0705 22.564 17.1934 20.2484 17.1934C17.9329 17.1934 16.0558 19.0705 16.0558 21.386C16.0558 23.7016 17.9329 25.5787 20.2484 25.5787Z",
  fill: "#FF9801"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2605 33.6842C34.576 33.6842 36.4531 31.807 36.4531 29.4915C36.4531 27.1759 34.576 25.2988 32.2605 25.2988C29.9449 25.2988 28.0678 27.1759 28.0678 29.4915C28.0678 31.807 29.9449 33.6842 32.2605 33.6842Z",
  fill: "#00BCD4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1449 21.3853C46.4604 21.3853 48.3375 19.5082 48.3375 17.1927C48.3375 14.8771 46.4604 13 44.1449 13C41.8293 13 39.9522 14.8771 39.9522 17.1927C39.9522 19.5082 41.8293 21.3853 44.1449 21.3853Z",
  fill: "#FFD15C"
});

function SvgTrendingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingIcon);
export default __webpack_public_path__ + "static/media/TrendingIcon.a2ed141b.svg";
export { ForwardRef as ReactComponent };